import { render, staticRenderFns } from "./step-datosAcademicos.vue?vue&type=template&id=439d07ce&"
import script from "./step-datosAcademicos.vue?vue&type=script&lang=js&"
export * from "./step-datosAcademicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports